<!-- 审核账户信息 -->
<script setup>
import { ref, onMounted, watch, inject } from 'vue';
// import companyImg from "@/assets/images/account/company.png"
import i18n from "@/i18n"
// import QRCode from "qrcode";
import { useRouter } from 'vue-router';
import { getFileUrl, database_template_name_v3, company_type_list } from "@/service/index"
import { showMessage } from "@/utils/hooks/message"
import PreviewImg from "@/components/common/PreviewImg";
import countryListData from '@/utils/country.js';
import CountryFlag from 'vue-country-flag-next'
import { dateFormat1 } from "@/utils/common.js";
import { getLangValue, getLangValueByKey, makeQrCode, switch_company_type_list_to_language_config } from "@/utils/common"; //获取后端语言
const countryList = ref(countryListData);
// const emits = defineEmits(['updateDetailInfo'])
const router = useRouter()
const detailInfo = inject('detailInfo')
const currendData = ref({})
const main_business_areas_list = ref([])
const typeForm = ref('info')
const current_tab = ref(0)
const companyAddressList = ref([])
const contact_address = ref([])
const showPreviewImg = ref(false)
const showPreviewImg1 = ref(false)
const qrcodeImgUrl = ref('')
const srcList = ref([])
const srcList1 = ref([])
const tabList = [
    getLangValue('my.account', "progressInfo1"),
    getLangValue("business-user", "detail_tab1"),
    // i18n.global.t("business_information_management.detail_tab2"),
]
const companyTypeList = ref([])
//账户信息
const accountInfo = [
    {
        name: getLangValue('my.account', "form_companyName"),
        key: 'company_name',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_Enterprisetype"),
        key: 'company_type',
        type: 'company_type',
    },
    {
        name: getLangValue("business-user", "accountEmail"),
        key: 'username',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_contacts"),
        key: 'contact_first_name,contact_last_name',
        type: 'contact',
    },
    {
        name: getLangValue('my.account', "form_email"),
        key: 'contact_email',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_phone"),
        key: 'landline_number',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_phone_number"),
        key: 'mobile_phone_number',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_main_business_areas"),
        key: 'business_scope',
        type: 'business_scope',
    },
    // {
    //     name: i18n.global.t("business_information_management.examine3"),
    //     key: 'examine_info',
    // }
]
// 企业信息
// const companyInfo = [
//     {
//         name:  getLangValue('my.account',"form_Enterprise_registered_address"),
//         key: 'place_of_incorporation',
//         type: 'place_of_incorporation',
//     },
//     {
//         name:  getLangValue('my.account',"form_Certificate_No"),
//         key: 'certificate_number',
//         type: 'text',
//     },
//     {
//         name:  getLangValue('my.account',"form_qualification_documents"),
//         key: 'file',
//         index: 0,
//     },
//     {
//         name:  getLangValue('my.account',"logo"),
//         key: 'file',
//         index: 1,
//     }
// ]
// 生产地址信息
const productAddress = [
    {
        name: getLangValue('my.account', 'form_country'),
        key: 'country',
        type: 'country',
    },
    {
        name: getLangValue('my.account', 'form_province'),
        key: 'province',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_province_code'),
        key: 'province_code',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_City'),
        key: 'city',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_address'),
        key: 'address',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_post'),
        key: 'postcode',
        type: 'text',
    }
];
// 联系人地址信息
const contactAddress = [
    {
        name: getLangValue('my.account', 'form_country'),
        key: 'country',
        type: 'country',
    },
    {
        name: getLangValue('my.account', 'form_province'),
        key: 'province',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_City'),
        key: 'city',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_address'),
        key: 'address',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_post'),
        key: 'postcode',
        type: 'text',
    }
];
const getTemplateList = async () => {
    const reps = await database_template_name_v3({ status: 1 })
    if (reps) {
        if (reps.payload.length == 0) {
            main_business_areas_list.value = [{ name: getLangValueByKey('base.none'), name_en: getLangValueByKey('base.none', 'en'), role_key: '无', }]
        } else {
            main_business_areas_list.value = reps.payload;
        }
    }
}
const setType = (filename) => {
    // 获取文件类型
    let fileType = filename.split('.').pop()
    if (fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png' || fileType == 'gif') {
        return 'image'
    } else if (fileType == 'dwg' || fileType == 'dwt' || fileType == 'dxf' || fileType == 'dwf') {
        return 'cad'
    }
    return 'file'
}

const viewFile = (type) => {
    /**展示附件信息 */
    // activeImageSrc.value = 'http://localhost:8080/static/img/company.29dfa381.png';
    // if (activeImageSrc.value == "") {
    //     return;
    // }
    // showPreviewImg.value = true;
    if (type == 0) {
        if (srcList.value.length == 0) {
            showMessage('info', getLangValue('base.no_pictures'))
            return
        }
        // 需要判断是图片还是附件
        const type = setType(srcList.value[0].name)
        if (type == 'image') {
            showPreviewImg.value = true;
        } else {
            window.open(srcList.value[0].url, '_blank')
        }
    } else {
        if (srcList1.value.length == 0) {
            showMessage('info', getLangValue('base.no_pictures'))
            return
        }
        showPreviewImg1.value = true;
    }
}
const handlerToggleTab = (i) => {
    current_tab.value = i
}

const makeCode = async () => {
    // 生产二维码
    const reps = await makeQrCode({ type: 1, id: currendData.value.id })
    if (reps) {
        qrcodeImgUrl.value = reps
    }
}

const getCountryBykey = (countryK) => {
    if (countryK) {
        let arr = countryListData.filter(item => item.key === countryK)
        if (arr.length > 0) {
            return i18n.global.locale == 'en' ? arr[0].en : arr[0].zh
        }
    }
    return ''
}
// const getCountrykey = (country) => {
//     if (country) {
//         let arr = countryListData.filter(item => item.zh === country)
//         if (arr.length > 0) {
//             return arr[0].key
//         }
//     }
//     return ''
// }

const getImage = async () => {
    // 获取图片
    let arr = currendData.value.company_logo ? [...currendData.value.company_qualification, ...[currendData.value.company_logo]] : [...currendData.value.company_qualification]
    let imgIdStr = arr.join(',')
    // console.log(imgIdStr);
    if (imgIdStr)
        getFileUrl({ attachments: imgIdStr }).then(resp => {
            if (resp) {
                //设置图片1
                let arr_qualification_documents = resp.payload.filter(item => currendData.value.company_qualification.includes(item.id))
                srcList.value = arr_qualification_documents
                // formData.value.qualification_documents = arr_qualification_documents

                //设置图片2
                let arr_logo = resp.payload.filter(item => currendData.value.company_logo.includes(item.id))
                srcList1.value = arr_logo
                // formData.value.logo = arr_logo

            }
        })
}

const checkFiles = (type) => {
    if (type == 0) {
        if (srcList.value.length == 0) {
            return false
        } else {
            return true
        }
    } else {
        if (srcList1.value.length == 0) {
            return false
        } else {
            return true
        }
    }

}
const getCompany_type_list = async () => {
    const reps = await company_type_list()
    if (reps.code == 0) {
        companyTypeList.value =  switch_company_type_list_to_language_config(reps.payload)
    }
}
const getCompanyTypeName = (str) => {
    // 根据企业类型id获取名字
    let arr = str ? str.split(',') : []
    let name = []
    for (const item in arr) {
        let arr1 = companyTypeList.value.filter(item1 => item1.id == arr[item])
        if (arr1.length) {
            name.push(arr1[0].name)
        }
    }
    return name.join(',')
}

const normalizeUrl =(url) => {
  if (!/^https?:\/\//i.test(url)) {
    return 'https://' + url;
  }
  return url;
}

const openWeb = (url) => {
    if(!url) return
    const safeUrl = normalizeUrl(url);
    window.open(safeUrl, '_blank')
}

onMounted(() => {
    // getDetailByid()
    // getCountrykey()
    getTemplateList()
    getCompany_type_list();
})

watch(detailInfo, (val) => {
    // console.log(val);
    if (val.wait_review_info && val.wait_review_info.company_name) {
        currendData.value = val.wait_review_info
        currendData.value.last_time = val.last_time
        currendData.value.create_time = val.create_time
        getImage();
        // let imgIdStr = currendData.value.company_qualification.join(',')
        // if (imgIdStr)
        //     getFileUrl({ attachments: imgIdStr }).then(resp => {
        //         if (resp) {
        //             srcList.value = resp.payload
        //         }
        //     })
        // let imgIdStr1 = currendData.value.company_logo
        // if (imgIdStr1)
        //     getFileUrl({ attachments: imgIdStr1 }).then(resp => {
        //         if (resp) {
        //             srcList1.value = resp.payload
        //         }
        //     })
        // 二维码
        makeCode();
    } else {
        showMessage('info', getLangValue('my.account', 'no_wait_review_info'))
        // return;
    }


})

const getFID =(item)=> {
    // 拼接 FBD-注册号-生产地址
    let res = ``;
    res = `FBD-${currendData.value.certificate_number}-${(item.country+ item.province + item.city + item.address).replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '')}`;
    return res;
}

const get_business_scope = (business_scope_list) => {
    // 获取信息
    let str = [];
    for (const item in business_scope_list) {
        const role_key = business_scope_list[item]
        let obj = main_business_areas_list.value.find(item => item.role_key === role_key)
        if (obj) {
            str.push(i18n.global.locale == 'en' ? obj.name_en : obj.name);
        }
    }
    return str.join('/');
}

const back =()=> {
    // 返回到详情页面
    router.push({ path: '/account' })
}

const getCountryName = (country) => {
    // 获取国家名称
    let arr = countryList.value.filter(item => item.zh === country || item.en === country)
    if (arr.length > 0) {
        return i18n.global.locale == 'en' ? arr[0].en : arr[0].zh
    }
}

watch(currendData, (val) => {
    // console.log(val);
    if (val.company_address)
        companyAddressList.value = val.company_address.map(item => {
            return {
                country: item.name,
                countryKey: item.country,
                province: item.province,
                province_code: item.province_code,
                city: item.city,
                address: item.address1,
                postcode: item.postcode,
            }
        })
    if (val.contact_address)
        contact_address.value = val.contact_address.map(item => {
            return {
                country: item.name,
                countryKey: item.country,
                province: item.province,
                city: item.city,
                address: item.address1,
                postcode: item.postcode,
            }
        })
})
</script>
<template>
    <div class="h-100">
        <div class="w-100  px-4 d-flex my-detail " style="overflow-y: auto; height: calc(100% - 1rem);">
            <div class="me-4" style="width: 400px; position: sticky; top: 0px;">
                <div class="card " style="min-height: 336px;">
                    <div
                        style="width: 160px; height: 160px; border-radius: 80px;border: 1px solid #E9EBEC; margin: 20px auto; ">
                        <!-- <img :src="srcList1.length? srcList1[0].url: ''"> -->
                        <el-upload class="upload-demo" :auto-upload="false" style="pointer-events: none;"
                            :on-change="(file, fileList) => handleChange(file, fileList)" :show-file-list="false">
                            <!-- <i class=" ri-add-circle-fill" style="color: #8591A2; font-size: 16px;"></i> -->
                            <img v-if="srcList1.length" :src="srcList1.length ? srcList1[0].url : ''"
                                style="border-radius: 80px;width: 150px; height: 150px;object-fit: contain;">
                            <Empty v-else :content="getLangValue('base.no_pictures')"></Empty>
                        </el-upload>
                        <b-button  variant="success" @click="back" style="min-width: 70px; 
                            height: 37px;
                            background-color: #0AB39C; 
                            position: absolute;
                            height: 27px;
                            padding: 0;
                            top:10px;
                            z-index: 1; 
                            right: 10px;">
                            {{ getLangValue('base', 'back') }}
                        </b-button>
                    </div>
                    <!-- <div v-if="currendData.certification_company"
                        style="background-color: #F3F6F9; color: #405189; text-align: center; font-size: 12px; font-weight: bold; min-width: 115px; margin: 0 auto;"
                        class="px-2">
                        {{  getLangValue('business-user','thirdCompany') }}
                    </div> -->
                    <div v-if="currendData.certification_company || currendData.testing_company"
                        style="background-color: #F3F6F9; color: #405189; text-align: center; font-size: 12px; font-weight: bold; min-width: 115px; margin: 0 auto;"
                        class="px-2">
                        <span class="mx-2" v-if="currendData.certification_company">{{
                            getLangValue('business-user', 'thirdCompany') }}</span>
                        <span class="mx-2" v-if="currendData.testing_company">{{
                            getLangValue('business-user', 'testingOrganization') }}</span>
                    </div>
                    <div class="d-flex my-4">
                        <div style="flex: 1; padding-left: 60px;font-weight: bold;">{{
                            getLangValue('business-user', 'registre_time') }}:</div>
                        <div style="flex: 1;color: #9599AD;">{{ currendData.create_time ?
                            dateFormat1(currendData.create_time) : '' }}</div>
                    </div>
                    <div class="d-flex">
                        <div style="flex: 1; padding-left: 60px;font-weight: bold;">{{
                            getLangValue('business-user', 'lastLoginTime') }}:</div>
                        <div style="flex: 1;color: #9599AD;">{{ currendData.last_time ?
                            dateFormat1(currendData.last_time) : '' }}</div>
                    </div>
                </div>
                <div class="card mt-2 p-3" style="height: 274px;">
                    <div style="font-size: 16px; color: #495057;">{{ getLangValue('business-user', 'passport')
                        }}</div>
                    <div style="width: 300px; height: 136px;margin: 0 auto;position: relative;" class="my-3">
                        <!-- <img :src="qrcodeImgUrl"> -->
                         <img src="@/assets/images/account/in_review.svg" alt="">
                         <div style="color: #9599AD;position: absolute; left: 50%; transform: translateX(-50%); bottom: 14px;">{{  getLangValue('business-user', 'examineing') }}</div>
                    </div>
                    <div style="text-align: center;font-size: 14px;">{{ currendData.place_of_incorporation +
                        currendData.certificate_number }}</div>
                </div>
            </div>
            <div class="card py-2 px-1 my-scroll-bar" style="flex: 1; overflow-y: auto;">
                <!-- tab -->
                <div class="d-flex justify-content-between">
                    <ul class="nav nav-tabs nav-tabs-custom nav-success d-flex align-items-center " role="tablist"
                        style="border-bottom: 1px solid #E9EBEC; padding: 0;">
                        <li class="nav-item" v-for="(tab, i) in tabList" :key="i"
                            style="min-width: 115px; text-align: center;">
                            <a :class="[
                                'nav-link',
                                'All',
                                'position-relative cursor',
                                i == current_tab && 'active',
                            ]" @click="handlerToggleTab(i)" style="color: #405189; font-weight: 600; font-size: 13px;">
                                {{ tab }}
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- 信息展示部分 -->
                <!-- 账户信息 -->
                <div class="account-info px-4" v-show="current_tab == 0">
                    <div class="d-flex" style="flex-wrap: wrap;">
                        <div v-for="(item, key) in accountInfo" :key="key" class="py-3" style="flex: 1; min-width: 50%">
                            <div style="font-weight: bold;" class="my-2">{{ item.name }}</div>
                            <div>
                                <div class="px-2" v-if="item.key != 'business_scope'">
                                    <span v-if="item.key == 'landline_number'">
                                        {{ getCountryName(currendData.landline_number_area) }}-
                                        {{ currendData.landline_number }}
                                    </span>
                                    <span v-else-if="item.key == 'mobile_phone_number'">
                                        {{ getCountryName(currendData.mobile_phone_number_area) }}-
                                        {{ currendData.mobile_phone_number }}
                                    </span>
                                    <span v-else-if="item.key == 'company_type'">
                                        {{ getCompanyTypeName(currendData.company_type) ?
                                            getCompanyTypeName(currendData.company_type) : currendData.company_type }}
                                    </span>
                                    <span v-else>{{ item.key.split(',').length
                                        > 1
                                        ?
                                        i18n.global.locale =='ch'? 
                                        currendData[item.key.split(',')[0]] +' '+ currendData[item.key.split(',')[1]] : currendData[item.key.split(',')[1]] +' '+ currendData[item.key.split(',')[0]]
                                        : currendData[item.key] }}
                                    </span>
                                </div>
                                <div class="px-2" v-else>{{ currendData['business_scope'] &&
                                    currendData['business_scope'].length ?
                                    get_business_scope(currendData['business_scope']) :
                                    ''
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 企业信息 -->
                <div class="account-info px-4" v-show="current_tab == 1">
                    <div class="d-flex" style="flex-wrap: wrap;">
                        <!-- <div v-for="(item, key) in companyInfo" :key="key" style="flex: 1; min-width: 50%">
                            <div class="py-3" v-if="(typeForm != 'edit' || (typeForm == 'edit' && item.key != 'file'))">
                                <div style="font-weight: bold;" class="my-2">{{ item.name }}</div>
                                <div v-if="typeForm != 'edit'">
                                    <div class="px-2" v-if="item.key != 'file'">{{ item.key == 'place_of_incorporation'
                                        ?
                                        getCountryBykey(currendData[item.key]) : currendData[item.key] }}</div>
                                    <div class="px-2 cursor-pointer" v-else>
                                        <a v-if="checkFiles(item.index)"
                                            style="color: #6691E7; text-decoration: underline !important;"
                                            @click="viewFile(item.index)">
                                            {{  getLangValue('business-user','viewfile') }}</a>
                                        <a v-else style="color: #6691E7;">{{ $t('upload.noUpload') }}</a>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div style="flex: 1; min-width: 50%">
                            <div class="py-3">
                                <div style="font-weight: bold;" class="my-2">
                                    <span class="text-danger" v-if="typeForm == 'edit'">*</span>
                                    {{ getLangValue('my.account', "form_Enterprise_registered_address") }}
                                </div>
                                <div v-if="typeForm != 'edit'">
                                    <div class="px-2 d-flex align-items-center">
                                        <country-flag :country='currendData["place_of_incorporation"]' size='small' />
                                        {{ getCountryBykey(currendData['place_of_incorporation']) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="flex: 1; min-width: 50%">
                            <div class="py-3">
                                <div style="font-weight: bold;" class="my-2">
                                    <span class="text-danger" v-if="typeForm == 'edit'">*</span>
                                    {{ getLangValue('my.account', "form_Certificate_No") }}
                                </div>
                                <div v-if="typeForm != 'edit'">
                                    <div class="px-2 d-flex align-items-center">
                                        {{ currendData.certificate_number }}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div style="flex: 1; min-width: 50%"
                            v-if="currendData.company_type && currendData.company_type.includes('7')">
                            <div class="py-3">
                                <div style="font-weight: bold;" class="my-2">
                                    <span class="text-danger" v-if="typeForm == 'edit'">*</span>
                                    {{ getLangValue('my.account', "form_qualification_certification") }}
                                </div>
                                <div v-if="typeForm != 'edit'">
                                    <div class="px-2 d-flex align-items-center">
                                        {{ currendData.company_qualification_validity_period }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="flex: 1; min-width: 50%"
                            v-if="currendData.company_type && currendData.company_type.includes('7')">
                            <div class="py-3">
                                <div style="font-weight: bold;" class="my-2">
                                    <span class="text-danger" v-if="typeForm == 'edit'">*</span>
                                    {{ getLangValue('my.account', "form_qualification_certification1") }}
                                </div>
                                <div v-if="typeForm != 'edit'">
                                    <div class="px-2 d-flex align-items-center">
                                        {{ currendData.company_qualification_certification_body }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="flex: 1; min-width: 50%">
                            <div class="py-3">
                                <div style="font-weight: bold;" class="my-2">
                                    <span class="text-danger" v-if="typeForm == 'edit'">*</span>
                                    {{ getLangValue('my.account', "form_company_link") }}
                                </div>
                                <div v-if="typeForm != 'edit'">
                                    <div class="px-2 d-flex align-items-center cursor-pointer" style="word-break: break-all;">
                                        <a @click="openWeb(currendData.company_website)"
                                            style="text-decoration: underline !important;color: #6691E7;">
                                            {{ currendData.company_website }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="flex: 1; min-width: 50%" v-if="typeForm != 'edit'">
                            <div class="py-3">
                                <div style="font-weight: bold;" class="my-2">
                                    {{ getLangValue('my.account', "form_qualification_documents") }}
                                </div>
                                <div>
                                    <div class="px-2 cursor-pointer" @click="viewFile(0)">
                                        <!-- <a style="color: #6691E7; text-decoration: underline !important;">
                                            {{
                                                 getLangValue('business-user','viewfile') }}</a> -->
                                        <a v-if="checkFiles(0)"
                                            style="color: #6691E7; text-decoration: underline !important;"
                                            @click="viewFile(0)">
                                            {{ getLangValue('business-user', 'viewfile') }}</a>
                                        <a v-else style="color: #6691E7;">{{ getLangValue('upload.noUpload') }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="flex: 1; min-width: 50%" v-if="typeForm != 'edit'">
                            <div class="py-3">
                                <div style="font-weight: bold;" class="my-2">
                                    <!-- <span class="text-danger" v-if="typeForm == 'edit'">*</span> -->
                                    {{ getLangValue('my.account', "logo") }}
                                </div>
                                <div>
                                    <div class="px-2 cursor-pointer" @click="viewFile(1)">
                                        <a v-if="checkFiles(1)"
                                            style="color: #6691E7; text-decoration: underline !important;"
                                            @click="viewFile(1)">
                                            {{ getLangValue('business-user', 'viewfile') }}</a>
                                        <a v-else style="color: #6691E7;">{{ getLangValue('upload.noUpload') }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 企业通讯地址 -->
                        <div class="d-flex" style="width: 100%;flex-wrap: wrap;border-top:1px dashed #0ab39c" v-for="(item, key) in contact_address"
                            :key="key">
                            <div class="my-2" style="width: 100%;flex-wrap: wrap; font-weight: bold;">{{
                                getLangValue("my.account", 'contactAddress') }}
                            </div>
                            <div v-if="typeForm != 'edit'" style="width: 100%;flex-wrap: wrap" class="d-flex ">
                                <div v-for="(item1, key1) in contactAddress" :key="key1" class="py-2"
                                    style="flex: 1; min-width: 50%">
                                    <div style="font-weight: bold;" class="my-2">{{ item1.name }}</div>
                                    <div class="px-2 d-flex align-items-center">
                                        <template v-if="item1.type == 'country'">
                                            <country-flag :country='item.countryKey' size='small' />
                                        </template>
                                        {{ item[item1.key] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 生产地址信息 -->
                        <div class="d-flex" style="width: 100%;flex-wrap: wrap;border-top:1px dashed #0ab39c"
                            v-for="(item, key) in companyAddressList" :key="key">
                            <div class="my-2" style="width: 100%;flex-wrap: wrap; font-weight: bold;">{{
                                getLangValue("my.account", 'enterprise_production_address') }}
                                {{ key + 1 }}
                                <div class="my-1"><span style="color:#0ab39c">{{getLangValue('product-management', "fid")}}</span> : <span style="font-weight: 400;">{{getFID(item)}}</span></div>
                            </div>
                            <div v-if="typeForm != 'edit'" style="width: 100%;flex-wrap: wrap" class="d-flex ">
                                <div v-for="(item1, key1) in productAddress" :key="key1" class="py-2"
                                    style="flex: 1; min-width: 50%">
                                    <div style="font-weight: bold;" class="my-2">{{ item1.name }}</div>
                                    <div class="px-2 d-flex align-items-center">
                                        <template v-if="item1.type == 'country'">
                                            <country-flag :country='item["countryKey"]' size='small' />
                                        </template>
                                        {{ item[item1.key] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <PreviewImg v-model:showPreviewImg="showPreviewImg" :srcList="srcList" v-if="showPreviewImg"></PreviewImg>
        <PreviewImg v-model:showPreviewImg="showPreviewImg1" :srcList="srcList1" v-if="showPreviewImg1"></PreviewImg>
    </div>
</template>

<style scoped lang="scss">
/* .active {
    background-color: #0AB39C !important;
} */
.my-detail {
    .nav-success.nav-tabs-custom .nav-link.active::after {
        background-color: #405189;
    }

    label {
        margin-bottom: 0px;
    }

    .myC-3 {
        padding: 0.5rem 0 0.5rem 0;
    }

    .is-invalid {
        border: 1px solid #f06548;
        border-radius: 4px;
    }

    .mx-3 {
        padding-left: 20px !important;
    }

    .is-invalid1 {
        border: 1px solid #f06548;
        border-right: unset !important;
    }

    :deep(.input-group-text .el-select__wrapper) {
        box-shadow: unset !important;
    }

    :deep(.el-select--large .el-select__wrapper) {
        min-height: 37.5px;
    }

    .upload-demo {
        width: 160px;
        height: 160px;

        :deep(.el-upload--text) {
            height: 100%;
            width: 100%;
        }
    }

    .noEdit {
        pointer-events: none;
    }
}
</style>